import { Component, output } from '@angular/core';

@Component({
  selector: 'app-logout-dialog',
  standalone: true,
  templateUrl: './logout-dialog.component.html',
})
export class LogoutDialogComponent {
  cancel = output<void>();
  confirm = output<void>();

  onBackdropClick(): void {
    this.cancel.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onConfirm(): void {
    this.confirm.emit();
  }
}
